// extracted by mini-css-extract-plugin
export default {"lastTableCell":"AdditionalParametersTable_lastTableCell__ivqPo"};